import { useEffect, useState } from "react";
import { getHeader, getFooter } from "../../services/api";
import { useNavigate } from "react-router-dom";
import { CMS_BASE_URL } from "../../config";
import logo from "../../assets/logo.webp";
import BackToTop from "./BackToTop";

export const TEAL = "#0f766e";
export const NAVY = "#1a3c6e";
export const ORANGE = "#B16116";
export const WHITE = "#ffffff";

export function SharedHeader() {
  const navigate = useNavigate();
  const [activeDD, setActiveDD] = useState(null);
const [menuOpen, setMenuOpen] = useState(false);
const [mobileExpandedItem, setMobileExpandedItem] = useState(null);
const [headerData, setHeaderData] = useState(null);
useEffect(() => {
  async function loadHeader() {
    try {
      const data = await getHeader();
      setHeaderData(data);
    } catch (err) {
      // silently fail — header will use fallback logo
    }
  }

  loadHeader();
}, []);
const convertCmsUrl = (url) => {
  if (!url) return "/";

  try {
    // new URL(url, CMS_BASE_URL) handles both absolute and relative URLs:
    // - Absolute: "https://glspharmaadmin.../facility/" → uses url as-is
    // - Relative: "/facility" or "facility" → resolved against CMS_BASE_URL
    const parsed = new URL(url, CMS_BASE_URL);
    // Preserve both pathname AND hash fragment (e.g. #job-openings)
    const path = (parsed.pathname + parsed.hash)
      .replace("/contact-us", "/contact")
      .replace(/\/$/, "");
    return path || "/";
  } catch {
    // Last resort fallback for truly malformed input
    return url
      .replace(/^https?:\/\/[^/]+/, "")
      .replace("/contact-us", "/contact")
      .replace(/\/$/, "") || "/";
  }
};

const desktopMenus =
  headerData?.menu?.filter((item) => item.title !== "Contact Us") || [];

const contactMenu =
  headerData?.menu?.find((item) => item.title === "Contact Us");
const enquiryItem = contactMenu?.children?.find(
  (item) => item.title === "Enquiry"
);
  const handleNav = (path) => {
    if (!path) return;
    // If path contains a hash, navigate then scroll to the element
    if (path.includes("#")) {
      const [route, hash] = path.split("#");
      navigate(route || "/");
      // Delay scroll slightly to allow page render
      setTimeout(() => {
        const el = document.getElementById(hash);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 100);
    } else {
      navigate(path);
    }
    setMenuOpen(false);
    setActiveDD(null);
  };

  return (
    <header
      style={{ background: WHITE, borderBottom: "1px solid #e0e8f0", position: "sticky", top: 0, zIndex: 200 }}
      onMouseLeave={() => setActiveDD(null)}
    >
      <div className="site-header-inner">
        <div style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer" }} onClick={() => handleNav("/")}>
          <img src={headerData?.logo || logo} alt="GLS Pharma" style={{ height: 70, objectFit: "contain", display: "block" }} />
        </div>

        {/* Desktop nav */}
        <nav className="site-nav" style={{ display: "flex", alignItems: "center", flex: 1, justifyContent: "space-between" }}>
          {/* Left side - empty for spacing */}
          <div></div>
          
          {/* Center - All navigation items except Contact Us */}
          <div style={{ display: "flex", alignItems: "center" }}>
            {desktopMenus.map((item) => {
              const hasDrop = item.children && item.children.length > 0;
              const open = activeDD === item.title;
              return (
                <div key={item.title} style={{ position: "relative" }} onMouseEnter={() => setActiveDD(hasDrop ? item.title : null)}>
                  <button
                    type="button"
                    onClick={() => {
                      // Only block navigation for Products (no landing page)
                      // All other parent items navigate even if they have dropdowns
                      if (item.title === "Products") return;
                      handleNav(convertCmsUrl(item.url));
                    }}
                    style={{ 
                      display: "flex", 
                      alignItems: "center", 
                      gap: 4, 
                      padding: "28px 18px", 
                      color: item.title === "Home" ? ORANGE : "#333", 
                      fontWeight: 600, 
                      fontSize: 14, 
                      cursor: item.title === "Products" ? "default" : "pointer", 
                      border: "none", 
                      background: "transparent",
                      borderBottom: item.title === "Home" ? `2px solid ${ORANGE}` : "2px solid transparent",
                      transition: "all 0.3s ease"
                    }}
                    onMouseEnter={(e) => {
                      if (item.title !== "Home") {
                        e.currentTarget.style.color = ORANGE;
                        e.currentTarget.style.borderBottomColor = ORANGE;
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (item.title !== "Home") {
                        e.currentTarget.style.color = "#333";
                        e.currentTarget.style.borderBottomColor = "transparent";
                      }
                    }}
                  >
                    {item.title}
                    {hasDrop && (
                      <svg width="9" height="6" viewBox="0 0 10 6" fill="none">
                        <path d="M1 1l4 4 4-4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                      </svg>
                    )}
                  </button>
                  {hasDrop && open && (
                    <div style={{ position: "absolute", top: "100%", left: 0, background: WHITE, minWidth: 210, boxShadow: "0 8px 32px rgba(0,0,0,0.12)", borderTop: `3px solid ${ORANGE}`, zIndex: 300 }}>
                      {item.children.map((sub) => (
                        <button
                          type="button"
                          key={sub.id}
                          onClick={() => handleNav(convertCmsUrl(sub.url))}
                          style={{ display: "block", width: "100%", textAlign: "left", padding: "13px 22px", color: "#333", fontSize: 14, borderBottom: "1px solid #f0f4f8", cursor: "pointer", border: "none", borderBottom: "1px solid #f0f4f8", background: "transparent" }}
                          onMouseEnter={(e) => (e.currentTarget.style.background = "#fff5f0")}
                          onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                        >
                          {sub.title}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
          
          {/* Right side - Contact Us */}
          <div style={{ display: "flex", alignItems: "center" }}>
  {contactMenu && (() => {
    const hasDrop = contactMenu.children?.length > 0;
    const open = activeDD === contactMenu.title;

    return (
      <div
        style={{ position: "relative" }}
        onMouseEnter={() =>
          setActiveDD(hasDrop ? contactMenu.title : null)
        }
      >
        <button
          type="button"
          onClick={() => {
            // Contact Us always navigates — dropdown is just for sub-items
            handleNav(convertCmsUrl(contactMenu.url));
          }}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 4,
            padding: "12px 24px",
            color: "#fff",
            fontWeight: 600,
            fontSize: 14,
            border: "none",
            background: NAVY,
            borderRadius: 8,
            cursor: hasDrop ? "default" : "pointer"
          }}
        >
          {contactMenu.title}

          {hasDrop && (
            <svg width="9" height="6" viewBox="0 0 10 6">
              <path
                d="M1 1l4 4 4-4"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
              />
            </svg>
          )}
        </button>

        {hasDrop && open && (
          <div
            style={{
              position: "absolute",
              top: "100%",
              right: 0,
              background: WHITE,
              minWidth: 210,
              boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
              borderTop: `3px solid ${ORANGE}`,
              zIndex: 300,
            }}
          >
            {contactMenu.children.map((sub) => (
              <button
                key={sub.id}
                type="button"
                onClick={() => handleNav(convertCmsUrl(sub.url))}
                style={{
                  display: "block",
                  width: "100%",
                  textAlign: "left",
                  padding: "13px 22px",
                  border: "none",
                  background: "transparent",
                  cursor: "pointer",
                }}
              >
                {sub.title}
              </button>
            ))}
          </div>
        )}
      </div>
    );
  })()}
</div>
        </nav>



        {/* Hamburger */}
        <button
          className="hamburger"
          onClick={() => setMenuOpen((o) => !o)}
          aria-label="Toggle menu"
          style={{ background: "none", border: "none", cursor: "pointer", padding: 8, display: "none" }}
        >
          {menuOpen ? (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#333" strokeWidth="2" strokeLinecap="round">
              <path d="M18 6 6 18M6 6l12 12" />
            </svg>
          ) : (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#333" strokeWidth="2" strokeLinecap="round">
              <path d="M3 12h18M3 6h18M3 18h18" />
            </svg>
          )}
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div style={{ background: WHITE, borderTop: "1px solid #e0e8f0", padding: "12px 20px 20px", boxShadow: "0 8px 24px rgba(0,0,0,0.1)", zIndex: 250 }}>
          {headerData?.menu?.map((item) => {
            const hasDrop = item.children && item.children.length > 0;
            const isExpanded = mobileExpandedItem === item.title;
            
            return (
              <div key={item.title}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <button
                    type="button"
                    onClick={() => {
                      if (hasDrop) {
                        setMobileExpandedItem(isExpanded ? null : item.title);
                      } else {
                        handleNav(convertCmsUrl(item.url));
                      }
                    }}
                    style={{ display: "block", flex: 1, textAlign: "left", padding: "12px 0", color: "#333", fontWeight: 600, fontSize: 15, border: "none", background: "transparent", borderBottom: "1px solid #f0f4f8", cursor: "pointer" }}
                  >
                    {item.title}
                  </button>
                  {hasDrop && (
                    <button
                      type="button"
                      onClick={() => setMobileExpandedItem(isExpanded ? null : item.title)}
                      style={{ padding: "12px 8px", border: "none", background: "transparent", cursor: "pointer", color: "#666" }}
                    >
                      <svg 
                        width="12" 
                        height="12" 
                        viewBox="0 0 12 12" 
                        fill="none" 
                        style={{ transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.2s" }}
                      >
                        <path d="M3 4.5l3 3 3-3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>
                  )}
                </div>
                
                {/* Sub-menu items */}
                {hasDrop && isExpanded && (
                  <div style={{ paddingLeft: 16, paddingBottom: 8 }}>
                    {item.children.map((sub) => (
                      <button
                        key={sub.id}
                        type="button"
                        onClick={() => handleNav(convertCmsUrl(sub.url))}
                        style={{ 
                          display: "block", 
                          width: "100%", 
                          textAlign: "left", 
                          padding: "10px 0", 
                          color: "#666", 
                          fontWeight: 500, 
                          fontSize: 14, 
                          border: "none", 
                          background: "transparent", 
                          cursor: "pointer",
                          borderBottom: "1px solid #f8f9fa"
                        }}
                      >
                        {sub.title}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
          <button
  onClick={() =>
    enquiryItem && handleNav(convertCmsUrl(enquiryItem.url))
  }
  style={{
    marginTop: 16,
    width: "100%",
    background: NAVY,
    color: "#fff",
    border: "none",
    borderRadius: 8,
    padding: "12px",
    fontWeight: 600,
    fontSize: 14,
    cursor: "pointer",
  }}
>
  {enquiryItem?.title || "General Enquiry"}
</button>
        </div>
      )}
      
      {/* Back to Top Button - appears on all pages */}
      <BackToTop />
    </header>
  );
}

export function SharedFooter() {
  const navigate = useNavigate();
  const [footerData, setFooterData] = useState(null);

useEffect(() => {
  async function loadFooter() {
    try {
      const data = await getFooter();
      setFooterData(data);
    } catch (err) {
      // silently fail
    }
  }

  loadFooter();
}, []);
const convertCmsUrl = (url) => {
  if (!url) return "/";

  try {
    const parsed = new URL(url, CMS_BASE_URL);
    return (
      parsed.pathname
        .replace("/contact-us", "/contact")
        .replace(/\/$/, "") || "/"
    );
  } catch {
    return url
      .replace(/^https?:\/\/[^/]+/, "")
      .replace("/contact-us", "/contact")
      .replace(/\/$/, "") || "/";
  }
};

  return (
    <footer
      style={{
        background: "#ffffff",
        padding: "50px 0 28px",
        color: "#444",
        borderTop: "1px solid #e5ecf9",
      }}
    >
      <div style={{ padding: "0 var(--pad-x, 80px)" }}>
        <div className="footer-inner">
          {/* Logo */}
          <div style={{ flex: 2 }}>
            <div
              style={{ marginBottom: 16, cursor: "pointer" }}
              onClick={() => navigate("/")}
            >
              <img
                src={footerData?.logo?.url || logo}
                alt="GLS Pharma"
                style={{
                  height: 42,
                  objectFit: "contain",
                  display: "block",
                }}
              />
            </div>

            <p
              style={{
                fontSize: 13,
                lineHeight: 1.7,
                maxWidth: 280,
                color: "#555",
              }}
            >
              {footerData?.description}
            </p>
          </div>

          {/* Company */}
          <div style={{ flex: 1.5 }}>
            <div
              style={{
                color: NAVY,
                fontWeight: 700,
                fontSize: 14,
                marginBottom: 16,
              }}
            >
              {footerData?.company_heading || "Company"}
            </div>

            {footerData?.company_menu?.map((item) => (
  <button
    key={item.title}
    type="button"
    onClick={() => navigate(convertCmsUrl(item.url))}
    style={{
      display: "block",
      color: "#555",
      fontSize: 13,
      marginBottom: 8,
      border: "none",
      background: "transparent",
      padding: 0,
      cursor: "pointer",
      transition: "color 0.3s ease",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.color = ORANGE;
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.color = "#555";
    }}
  >
    {item.title}
  </button>
))}
          </div>

          {/* Contact */}
          <div style={{ flex: 2 }}>
            <div
              style={{
                color: NAVY,
                fontWeight: 700,
                fontSize: 14,
                marginBottom: 16,
              }}
            >
              {footerData?.contact_heading || "Contact"}
            </div>

            <div style={{ fontSize: 13, lineHeight: 1.9, color: "#555" }}>
              <div>{footerData?.company_name}</div>
              {footerData?.address
  ?.split(/\r?\n/)
  .map((line, index) => (
    <div key={index}>{line}</div>
))}

              <div>{footerData?.email}</div>

              <div>{footerData?.phone}</div>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div
          className="footer-bottom"
          style={{
            borderTop: "1px solid #e5ecf9",
            paddingTop: 20,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div style={{ fontSize: 12, color: "#575757" }}>
            {footerData?.copyright}
          </div>

          <div style={{ display: "flex", gap: 24 }}>
            {footerData?.bottom_menu?.map((item) => (
  <button
    key={item.title}
    type="button"
    onClick={() => navigate(convertCmsUrl(item.url))}
    style={{
      color: "#575757",
      fontSize: 12,
      border: "none",
      background: "transparent",
      padding: 0,
      cursor: "pointer",
      transition: "color 0.3s ease",
    }}
    onMouseEnter={(e) => { e.currentTarget.style.color = ORANGE; }}
    onMouseLeave={(e) => { e.currentTarget.style.color = "#575757"; }}
  >
    {item.title}
  </button>
))}
          </div>
        </div>
      </div>
    </footer>
  );
}
export function PageHero({ label, title, subtitle, bgColor, bgImage }) {
  const heroStyle = bgImage
    ? {
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center center",
        backgroundRepeat: "no-repeat",
      }
    : { background: bgColor || NAVY };

  return (
    <section
  className="page-hero"
  style={{
    ...heroStyle,
    position: "relative",
    overflow: "hidden",
    display: "flex",
    alignItems: "center"
  }}
>

      <div style={{ position: "relative", zIndex: 2, maxWidth: 650 }}>
        <div style={{ color: ORANGE, fontWeight: 700, fontSize: 12, letterSpacing: 3, textTransform: "uppercase", marginBottom: 14 }}>{label}</div>
        <h1 className="page-hero-h1" style={{ color: "#fff", fontSize: 48, fontWeight: 800, margin: "0 0 18px", lineHeight: 1.15 }}>{title}</h1>
        <p style={{ color: "#fff", fontSize: 17, lineHeight: 1.7, margin: 0 }}>{subtitle}</p>
      </div>
    </section>
  );
}

export function Breadcrumb({ items }) {
  const navigate = useNavigate();
  return (
    <div className="breadcrumb-inner" style={{ background: "#f5f7fb", borderBottom: "1px solid #e5ecf9", display: "flex", alignItems: "center", gap: 8, fontSize: 13 }}>
      {items.map((item, i) => (
        <span key={i} style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {i < items.length - 1 ? (
            <button
              type="button"
              onClick={() => navigate(item.path)}
              style={{ color: NAVY, cursor: "pointer", fontWeight: 500, border: "none", background: "transparent", padding: 0, fontSize: 13 }}
              onMouseEnter={(e) => (e.currentTarget.style.color = ORANGE)}
              onMouseLeave={(e) => (e.currentTarget.style.color = NAVY)}
            >
              {item.label}
            </button>
          ) : (
            <span style={{ color: "#575757", fontWeight: 600 }}>{item.label}</span>
          )}
          {i < items.length - 1 && <span style={{ color: "#575757" }}>›</span>}
        </span>
      ))}
    </div>
  );
}
